import * as React from "react";
import { useNavigate } from "react-router";

import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExploreIcon from "@mui/icons-material/Explore";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

export default function TakeAssessmentCard(): React.JSX.Element {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate("/journeys/assessments");
    };

    return (
        <Box
            onClick={handleClick}
            sx={{
                cursor: "pointer",
                borderRadius: 2,
                overflow: "hidden",
                background: (theme) =>
                    `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 60%, ${theme.palette.secondary.main} 100%)`,
                minHeight: 95,
                width: "100%",
                p: 2,
                display: "flex",
                alignItems: "center",
                position: "relative",
                "&:hover": {
                    "& .chevron": {
                        transform: "translateX(4px)",
                    },
                },
            }}
        >
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{ width: "100%" }}
            >
                <Stack spacing={0.5}>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <ExploreIcon
                            sx={{
                                color: "secondary.main",
                                fontSize: 20,
                            }}
                        />
                        <Typography
                            variant="h4"
                            sx={{
                                color: "#fff",
                                fontWeight: "bold",
                            }}
                        >
                            Start Your Volley Journey
                        </Typography>
                    </Stack>
                    <Typography
                        variant="body2"
                        sx={{
                            color: "rgba(255,255,255,0.7)",
                            fontSize: "0.75rem",
                        }}
                    >
                        Take skill assessments to get feedback on your game
                    </Typography>
                </Stack>

                <ChevronRightIcon
                    className="chevron"
                    sx={{
                        color: "#fff",
                        fontSize: 32,
                        opacity: 0.7,
                        transition: "transform 0.2s ease",
                    }}
                />
            </Stack>
        </Box>
    );
}
